import { upgradeDelta, } from "../api/myClub/recommendations";
import { getPlayers } from "../api/players/getPlayers";
import { sbcSetStatus } from "../utils/sbcListControls";
import { slotForRecommendation } from "./squad";
/*
  The figures behind the club home's "For your club" cards: what each card
  can say about this club in particular. Each is optional; a card without its
  figure falls back to its general copy.
*/
/**
 * The stored recommendation that lifts the squad's meta rating the most, with
 * the incoming player's own rise and the slot's rating and role today.
 */
export const topUpgrade = (recommendations, squad) => {
    const best = recommendations
        .filter((rec) => rec.newPlayer)
        .map((rec) => ({ rec, delta: upgradeDelta(rec, "team-meta-upgrade") }))
        .sort((a, b) => b.delta - a.delta)[0];
    if (!best || best.delta <= 0)
        return undefined;
    const slot = slotForRecommendation(squad, best.rec.oldPlayer);
    return {
        ...best,
        playerDelta: upgradeDelta(best.rec, "player-meta-upgrade"),
        slotMeta: slot?.metaRating,
        slotRoleId: slot?.playerRoleId,
    };
};
const MARQUEE = /marquee matchups/i;
export const isMarquee = (set) => MARQUEE.test(set.name);
/**
 * The SBC to do next: Marquee Matchups while it is open, else the most
 * upvoted player SBC the club can cover.
 */
export const nextSbc = (sbcSets, sbcFodder) => {
    const open = sbcSets.filter((set) => sbcSetStatus(set) === "available" && !set.unsolvable);
    const marquee = open.find(isMarquee);
    if (marquee)
        return marquee;
    return open
        .filter((set) => set.reward?.type === "player" &&
        !!set.reward.player &&
        // A streamline SBC needs item score: only one the club's fodder
        // covers. (Other SBCs have no fodder figure to compare yet.)
        (set.kind !== "STREAMLINE" || (set.pointsRequired ?? 0) <= sbcFodder))
        .sort((a, b) => b.upVotes - a.upVotes)[0];
};
/* How far down the evolutions list to look for a starter. */
const STARTER_PAGES = 3;
/**
 * The best evolution player, as the evolutions list sorts them. With
 * `among`, the best of those cards only: the list's active squad filter
 * counts the bench too, while the card is about the starting eleven.
 */
export const bestEvolution = async (query, evoIds, mustIncludeEvoIds, among) => {
    for (let page = 1; page <= (among ? STARTER_PAGES : 1); page++) {
        const { players } = await getPlayers({
            page,
            evolutions: true,
            evoIds,
            mustIncludeEvoIds,
            ...query,
        });
        const best = among
            ? players.find((player) => among.has(player.resourceId))
            : players[0];
        if (best)
            return (best.metaRatingDelta ?? 0) > 0
                ? { player: best, delta: best.metaRatingDelta }
                : undefined;
        if (!players.length)
            return undefined;
    }
    return undefined;
};
/* The squad builder card spends half the club's coins, in steps of 5K. */
const BUDGET_SHARE = 0.5;
const BUDGET_STEP = 5000;
export const squadBuilderBudget = (coins) => Math.max(BUDGET_STEP, Math.round((coins * BUDGET_SHARE) / BUDGET_STEP) * BUDGET_STEP);
/** The best possible squad's meta rating, and its gain on the active one. */
export const bestSquadGain = (best, active) => best?.metaRating != null && active?.metaRating != null
    ? {
        metaRating: best.metaRating,
        delta: best.metaRating - active.metaRating,
    }
    : undefined;
//# sourceMappingURL=insights.js.map